<span class="jumping-dots">
    <span>.</span><span>.</span><span>.</span>
</span>